var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Radio } from "../Radio";
import { clsx } from "clsx";
import styles from "./RadioButton.module.scss";
export var RadioButtonSize;
(function (RadioButtonSize) {
    RadioButtonSize["Small"] = "Small";
    RadioButtonSize["Large"] = "Large";
})(RadioButtonSize || (RadioButtonSize = {}));
export const RadioButton = React.forwardRef((_a, ref) => {
    var { text, description, size: sizeProp, checked, disabled, onChange, direction, className } = _a, props = __rest(_a, ["text", "description", "size", "checked", "disabled", "onChange", "direction", "className"]);
    const changeHandler = () => {
        if (!disabled) {
            onChange === null || onChange === void 0 ? void 0 : onChange();
        }
    };
    const size = Boolean(description) ? RadioButtonSize.Large : sizeProp;
    return (React.createElement("div", Object.assign({ className: clsx(styles.Container, {
            [styles.Checked]: checked,
            [styles.Disabled]: disabled,
            [styles.Large]: size == RadioButtonSize.Large,
        }, className), style: { direction: direction }, onClick: changeHandler, ref: ref }, props),
        React.createElement("div", { className: styles.Content },
            React.createElement("div", { className: styles.TitleWrapper },
                React.createElement(Radio, { checked: checked, disabled: disabled, onChange: changeHandler }),
                React.createElement("p", { className: clsx(styles.Title, {
                        [styles.DisabledText]: disabled,
                    }) }, text)),
            React.createElement("div", { className: clsx(styles.Description, {
                    [styles.DisabledText]: disabled,
                }) }, description))));
});
RadioButton.defaultProps = {
    size: RadioButtonSize.Small,
};
//# sourceMappingURL=RadioButton.js.map